<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center">
					<panel :title="$t('eny.privacy_consent')" addclass="mt-4">
						<form id="privacy-consent-data-form">
							<div class="flex flex-col">
								<!-- Consented -->
								<div class="lg:mx-20 mt-7 form-group">
									<validation><ejs-checkbox id="consented_conditions" name="consented_conditions" :label="$t('eny.consented_conditions')" v-model:checked="consented_conditions" :value="consented_data_protection ? 1 : 0"></ejs-checkbox></validation>
									<div class='p-4 text-lg font-bold'><a target="_blank" href='https://eny.ch/nutzungsbedingungen/'>{{ $t('eny.conditions_consent') }}</a></div>
									<validation cssClass="mt-7"><ejs-checkbox id="consented_data_protection" name="consented_data_protection" :label="$t('eny.consented_data_protection')" v-model:checked="consented_data_protection" :value="consented_data_protection ? 1 : 0"></ejs-checkbox></validation>
									<div class='p-4 text-lg font-bold'><a target="_blank" href='https://eny.ch/datenschutzerklaerung/'>{{ $t('eny.dataprotection_consent') }}</a></div>
									<validation cssClass="mt-7"><ejs-checkbox id="consented_data_legally" name="consented_data_legally" :label="$t('eny.consented_data_legally')" v-model:checked="consented_data_legally" :value="consented_data_protection ? 1 : 0"></ejs-checkbox></validation>
									<div class='p-4 text-lg font-bold'><a target="_blank" :href="$t('eny.legally_link')"> {{ $t('eny.legally_consent') }}</a></div>
								</div>
							</div>
						</form>
					</panel>
					<!-- Buttons -->
					<div class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-2 sm:gap-6">
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="confirm">{{$t('eny.accept')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import { CheckBoxComponent } from "@syncfusion/ej2-vue-buttons";
import Panel from "../Base/Panel.vue";
import Validation from "../Base/Validation.vue";
import useNotification from "../hooks/useNotification";

export default {
	name: "UserPrivacyConsent",
	components: {
		'panel': Panel,
		'validation': Validation,
		'ejs-checkbox': CheckBoxComponent,
	},
	setup() {
		const { showNotification, hideNotification } = useNotification();
		return {
			showNotification,
			hideNotification,
		}
	},
	data() {
		return {
			formObject: '',
			consented_conditions: 0,
			consented_data_protection: 0,
			consented_data_legally: 0,
		};
	},
	mounted() {
		var options = {
			rules: {
				consented_conditions: { range: [this.isCheckedConsentedConditions, this.$t('eny.privacy_consent_notempty_error_msg')] },
				consented_data_protection: { range: [this.isCheckedConsentedDataProtection, this.$t('eny.privacy_consent_notempty_error_msg')] },
				consented_data_legally: { range: [this.isCheckedConsentedLegally, this.$t('eny.privacy_consent_notempty_error_msg')] },
			},
			customPlacement: this.showValidationError,
		};
		this.formObject = new FormValidator("#privacy-consent-data-form", options);
		this.consented_conditions = this.consented_data_protection = this.consented_data_legally = this.user.consented;
		this.window.stopNavigation=1;
	},
	//prevent navigating from the page if not constented
	beforeRouteLeave () {
  	return !this.window.stopNavigation;
	},
	computed: {
		...mapGetters('user', ['user', 'success', 'message']),
		isMerchant: function() {
			return this.$keycloak.hasRealmRole('merchantAdmin') || this.$keycloak.hasRealmRole('merchant');
		},
	},
	methods: {
		isCheckedConsentedConditions: function() {
			return this.consented_conditions == 1;
		},
		isCheckedConsentedDataProtection: function(args) {
			return this.consented_data_protection == 1;
		},
		isCheckedConsentedLegally: function(args) {
			return this.consented_data_legally == 1;
		},
		confirm: function() {
			if (this.formObject.validate()) {
				this.user.consented = this.consented_conditions & this.consented_data_protection;
				this.$store.dispatch('user/update_consented', this.user)
				.then(() => {
					this.window.stopNavigation=0;
					this.$router.push("/dashboard");
				}).catch(() => {
					console.error("update private consent request failed")
				})
			}
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
	},
	watch: {
		message(value) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
	}
}
</script>
<style>
</style>
